export function initUpload(type) {

  //export function initUpload() {
  //
  var arr = [
    /*{
        item: '<button class="btn-primary" type="button"></button>',
        event: 'click',
        btntext: 'Test',
        callback: function( event ){
            $('.upload').show();
            $('#resultDiv').hide(); }
          },*/
    {
      item: '<button class="btn-primary" type="button"></button>',
      event: 'click',
      btntext: 'Lukk',
      callback: function(event) {
        event.data.close()
      }
    }
  ];
  var headerText = 'Last opp fil:'
  if (type === 'draw') {
    headerText = 'Resultat arealberegning:'
  }

  var upLoadPanel = $.jsPanel({
    id: 'uploadPanel',
    title: headerText,
    resizable: {
      handles: 'se'
    },
    size: {
      width: window.innerWidth / 2,
      height: (window.innerHeight / 2)
    },
    position: {
      left: (window.innerWidth / 4 + 20),
      top: 100
    },
    // theme:    'light',
    overflow: 'auto',
    ajax: {
      url: 'upload.html?random='+ Math.random(),
      done: function(data, textStatus, jqXHR, panel) {
        $('#chooseAttr').hide();
        if (type === 'draw') {
          $('.upload').hide();
          $('#result').text('Beregner resultat...');
        } else {
          $('#resultDiv').hide();
        }

        $('input[name="r1"]').change(function(e) { // Select the radio input group
          var radioVal = $(this).val();
          if (radioVal === 'sosi') {
            $('#chooseAttr').hide();
          } else {
            $('#chooseAttr').show();
          }
        });



        $('#uploadButton').click(function(e) {
          alert('Beregningen kan ta tid, opp til 5 minutter. Det gjelder spesielt ved lasting av stor og kompleks reguleringsplan.')
          e.preventDefault();
          //Disable submit button
          //$(this).prop('disabled', true);



          var form = document.forms[0];
          var formData = new FormData(form);

          // Ajax call for file uploaling
          $.ajax({
            url: '/kostra_ws/upload',
            type: 'POST',
            data: formData,
            cache: false,
            contentType: false,
            //contentType: "charset=utf-8",
            processData: false,
            dataType: 'html',

            xhrFields: {
              withCredentials: true
            },
            beforeSend: function(xhr) {
              $('.upload').hide();
              $('#resultDiv').show();
              $('#result').text('Laster opp fil og beregner...');
            },
            success: function(result, textStatus, status) {
              $('#result').html(result);
            },
            error: function(error) {
              $('#result').html('Noe feilet: ' + error.statusText + ' : ' + error.status);
            },
            /*  complete: function(complete) {

              }*/
          });

        });

        function downloadCSV(csv, filename) {
          var csvFile;
          var downloadLink;

          // CSV file
          csvFile = new Blob(["\ufeff", decodeURIComponent(csv)], {
            type: "text/csv;charset=utf-8"
          });

          // Download link
          downloadLink = document.createElement("a");

          // File name
          downloadLink.download = filename;

          // Create a link to the file
          downloadLink.href = window.URL.createObjectURL(csvFile);

          // Hide download link
          downloadLink.style.display = "none";

          // Add the link to DOM
          document.body.appendChild(downloadLink);

          if (window.navigator.msSaveOrOpenBlob){ // IE 11
            navigator.msSaveBlob(csvFile, "kostra.csv")
          } else {
            var event = new MouseEvent('click', {
              'view': window,
              'bubbles': true,
              'cancelable': true
            });
            downloadLink.dispatchEvent(event);
          }

        }

        function exportTableToCSV(filename) {
          var csv = [];
          var regFormaal = true;
          var rows = document.querySelectorAll("[id^='regulering'] tr");

          if (rows.length > 0) {
            for (var i = 0; i < rows.length; i++) {
              var row = [],
                cols = rows[i].querySelectorAll("td, th");
              for (var j = 0; j < cols.length; j++)
                row.push(cols[j].innerText);
              csv.push(row.join(";"));
            }

            csv.push('');
          } else {
            regFormaal = false;
          }

          var rowsAreal = document.querySelectorAll("[id^='areal'] tr");

          if (rowsAreal.length > 0) {

            for (var k = 0; k < rowsAreal.length; k++) {
              var row = [],
                cols = rowsAreal[k].querySelectorAll("td, th");

              for (var j = 0; j < cols.length; j++) {
                const t = cols[j].innerText;
                if (t.indexOf(';') < 0) { row.push(t); }
                else { row.push('"' + t + '"'); }
              }

              csv.push(row.join(";"));
            }

            // Download CSV file
            downloadCSV(csv.join("\n"), filename);
          } else {
            if (!regFormaal){
              alert('Fant ingen tabell med resultat');
            }
          }
        }

        $('#againButton').click(function(e) {
          $('.upload').show();
          $('#resultDiv').hide();
        });

        $('#csvButton').click(function(e) {
          exportTableToCSV('kostra.csv');

          //var args = [$('#areal'), 'export.csv'];

          //exportTableToCSV.apply(this, args);
        });




      }
    },
    toolbarFooter: arr
  });

  upLoadPanel.on('jspanelbeforeclose', function(){
     // $('#draw_button').removeClass("down");
     $('#upload_button').removeClass("down");
  });
  // $('#uploadPanel').hide();
  $('#result_footer').hide();
}
